import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { render } from 'atoms/ParseBBCode/bbob-react-lib';
import { useTranslations } from 'modules/i18n/useTranslations';
import { IWishlistIconView } from './types';
import styles from './styles.module.css';

export const WishlistIconView: FC<IWishlistIconView> = ({
  className,
  variantId,
  addToWishlist,
  removeFromWishlist,
  wishlist,
  productName,
  pageType,
}) => {
  const t = useTranslations();
  const activeItem = wishlist?.items.find(
    (item) => item.variantId === variantId,
  );

  const handleClick = () => {
    const notificationMessage = t.rich(
      `wishlist.notification.${activeItem?.key ? 'remove' : 'add'}`,
      {
        productName: render(productName) as unknown as string,
        strong: (chunks) => <b>{chunks}</b>,
      },
    ) as string;

    if (activeItem?.key) {
      removeFromWishlist?.(activeItem.key, notificationMessage, pageType);
    } else {
      variantId && addToWishlist?.(variantId, notificationMessage, pageType);
    }
  };

  return (
    <Icon
      type={!!activeItem ? IconType.heart : IconType.heartbordered}
      className={clsx(styles.root, className)}
      onClick={handleClick}
    />
  );
};
